import CreatorFlag from './CreatorFlag';

export default CreatorFlag;